import { render, staticRenderFns } from "./tab7.vue?vue&type=template&id=0dc80c08&scoped=true"
import script from "./tab7.vue?vue&type=script&lang=js"
export * from "./tab7.vue?vue&type=script&lang=js"
import style0 from "./tab7.vue?vue&type=style&index=0&id=0dc80c08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc80c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc80c08')) {
      api.createRecord('0dc80c08', component.options)
    } else {
      api.reload('0dc80c08', component.options)
    }
    module.hot.accept("./tab7.vue?vue&type=template&id=0dc80c08&scoped=true", function () {
      api.rerender('0dc80c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab7.vue"
export default component.exports